module.exports = __webpack_public_path__ + "static/composer-success-8a2785553c942e0d3b460e0636ce7473.png";